function remove(array, value) {
  const i = array.indexOf(value);

  return [...array.slice(0, i), ...array.slice(i + 1)];
}

export default remove;
